import api from "../lib/axios";

const BASE_URL = "/Client";

export const clientService = {
  getPublishedAsync: async () => {
    const response = await api.get(`${BASE_URL}/get-published`);
    return response.data;
  },
  getBySlugAsync: async (slug) => {
    const response = await api.get(`${BASE_URL}/get-by-slug/${slug}`);
    return response.data;
  },
};
